<template>
  <div v-if="items.isLoading" class="ml-4 py-1 pl-8 pr-1 text-xs font-extralight text-gray-500 leading-6">Loading...</div>

  <div v-else-if="!items.items?.length" class="ml-4 py-1 pl-8 pr-1 text-xs font-light text-gray-500 leading-6">( empty )</div>

  <ul v-else role="list" class="ml-4">
    <li v-for="item in items.items" :key="item.id">
      <a
        class="group flex items-center gap-x-2 rounded-md py-1 px-1 text-sm leading-6 text-gray-700 hover:text-primary-600 hover:bg-primary-100 cursor-pointer"
        @click.stop="onClick(item, depth)"
      >
        <ChevronRight
          v-if="depth != maxDepth"
          :size="20"
          class="h-5 w-5 shrink-0 text-primary-600"
          :class="{ 'rotate-90': item.isOpened }"
        />
        <CircleSmall
          v-else
          :size="20"
          class="h-5 w-5 shrink-0 text-primary-600"
        />
        {{ item.name }}
        <span v-if="item.items !== undefined" class="text-xs font-extralight text-gray-500 leading-6">({{ item.items.length }})</span>
        <span v-if="item.number !== undefined" class="text-xs font-extralight text-gray-500 leading-6">#{{ item.number }}</span>

        <button class="ml-auto bg-transparent text-sm text-primary-400 hover:text-primary-500 cursor-pointer" @click.stop.prevent="onPlanClick(item)">
          <FloorPlan class="h-4 w-4 shrink-0 text-current" />
        </button>
      </a>

      <template v-if="item.isOpened">
        <tree-view :items="{ isLoading: item.isLoading, items: item.items }" :depth="depth + 1" @click="onClick" @plan-click="onPlanClick" />
      </template>
    </li>
  </ul>
</template>

<script setup>
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue';
import CircleSmall from 'vue-material-design-icons/CircleSmall.vue';
import FloorPlan from 'vue-material-design-icons/FloorPlan.vue';

const props = defineProps({
  items: {
    type: Object,
    required: true
  },
  depth: {
    type: Number,
    default: 0
  },
  maxDepth: {
    type: Number,
    default: 1
  }
});

const emit = defineEmits([ 'click', 'plan-click' ]);

function onClick(item, depth) {
  emit('click', item);

  if (depth !== props.depth) {
    return;
  }

  if (depth === props.maxDepth) {
    return;
  }

  item.isOpened = !item.isOpened;
}

function onPlanClick(item) {
  emit('plan-click', item);
}
</script>
